import React from 'react'
import PropTypes from 'prop-types'

const Star = ({ color = '#FFC422', onClick, className = '' }) => (
  <svg
    className={`${className}`}
    onClick={onClick}
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Icons-/-Color-/-Star" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <path
        d="M11.5346589,17.7446443 L7.32783438,19.9563028 C6.83898979,20.2133036 6.23436264,20.0253571 5.97736183,19.5365125 C5.87502276,19.3418521 5.83970808,19.118884 5.87688493,18.9021263 L6.68031691,14.2177584 C6.73595485,13.8933644 6.62840637,13.5623642 6.39272028,13.332627 L2.98932777,10.0151392 C2.59384419,9.62963801 2.58575189,8.99652475 2.9712531,8.60104117 C3.1247617,8.44355754 3.32590411,8.34107036 3.54354115,8.30944585 L8.24691392,7.62600578 C8.57262408,7.57867732 8.85418966,7.37410795 8.99985168,7.07896448 L11.1032639,2.81698575 C11.3476862,2.32173209 11.9473121,2.11839309 12.4425657,2.36281539 C12.6397783,2.46014562 12.7994058,2.61977315 12.8967361,2.81698575 L15.0001483,7.07896448 C15.1458103,7.37410795 15.4273759,7.57867732 15.7530861,7.62600578 L20.4564589,8.30944585 C21.0030037,8.38886347 21.3816852,8.89630632 21.3022676,9.44285118 C21.270643,9.66048821 21.1681559,9.86163062 21.0106722,10.0151392 L17.6072797,13.332627 C17.3715936,13.5623642 17.2640451,13.8933644 17.3196831,14.2177584 L18.1231151,18.9021263 C18.2164761,19.4464628 17.8508883,19.9634187 17.3065518,20.0567797 C17.0897942,20.0939566 16.8668261,20.0586419 16.6721656,19.9563028 L12.4653411,17.7446443 C12.1740171,17.5914862 11.8259829,17.5914862 11.5346589,17.7446443 Z"
        id="Star"
        fill={color}
      />
    </g>
  </svg>
)

Star.propTypes = {
  color: PropTypes.string,
  onClick: PropTypes.func,
  className: PropTypes.string,
}

export default Star
